import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { globalConfig } from "../../config/Messages/globalConfig";

// Ensure a single Firebase app instance across the app
const app = initializeApp(globalConfig.firebaseConfig);

console.log("app: ", app);
const auth = getAuth();
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
